import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearLogoutAuthState, logoutUser } from "../components/Auth/AuthSlice";
import { clearAuthStorage } from "../lib/utility";
import { persistor } from "../redux/store";

export const useInactive = (user, stallTime = 300000) => {
  const inactivityTimeout = useRef(); 
  const dispatch = useDispatch(); 
  const navigate = useNavigate();

  function resetInactivityTimeout() {
    clearTimeout(inactivityTimeout.current); 
    inactivityTimeout.current = setTimeout(onInactivity, stallTime); 
  }

  function onInactivity() {
    console.error("User has not moved"); 

    dispatch(logoutUser()).then(() => {
      dispatch(clearLogoutAuthState());
      clearAuthStorage(); 
      persistor.purge(); 
      document.body.classList.remove("dark-mode");
      navigate("/login"); 
      globalThis.profileData = null;
    });

    document.removeEventListener("mousemove", resetInactivityTimeout);
    document.removeEventListener("mousedown", resetInactivityTimeout); 
    document.removeEventListener("keydown", resetInactivityTimeout); 
    document.removeEventListener("scroll", resetInactivityTimeout);
  }

  useEffect(() => {
    if (!user || !user?.roles) return;

    document.addEventListener("mousemove", resetInactivityTimeout);
    document.addEventListener("mousedown", resetInactivityTimeout); 
    document.addEventListener("keydown", resetInactivityTimeout); 
    document.addEventListener("scroll", resetInactivityTimeout); 

    resetInactivityTimeout();

    return () => {
      clearTimeout(inactivityTimeout.current);
    };
  }, [user]);
};
